import { render, staticRenderFns } from "./WidthHeightProgress.vue?vue&type=template&id=becaaedc"
import script from "./WidthHeightProgress.vue?vue&type=script&lang=js"
export * from "./WidthHeightProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports